import { __require as requireGlobalThis } from './node_modules-core-js-internals-global-this.js';
import { __require as requireIsObject } from './node_modules-core-js-internals-is-object.js';

var documentCreateElement;
var hasRequiredDocumentCreateElement;

function requireDocumentCreateElement () {
	if (hasRequiredDocumentCreateElement) return documentCreateElement;
	hasRequiredDocumentCreateElement = 1;
	var globalThis = requireGlobalThis();
	var isObject = requireIsObject();

	var document = globalThis.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS = isObject(document) && isObject(document.createElement);

	documentCreateElement = function (it) {
	  return EXISTS ? document.createElement(it) : {};
	};
	return documentCreateElement;
}

export { requireDocumentCreateElement as __require };
//# sourceMappingURL=node_modules-core-js-internals-document-create-element.js.map
